import type { Capability, User } from "@/graphql.ts";
import type { CAPABILITY } from "@/settings/settings.ts";

export interface IRestrictedByCapability {
  capability?: CAPABILITY; // in order to be able to filter by capability
}

export const getUserTooltipDisplayName = (user: Pick<User, "username" | "firstName" | "lastName">): string =>
  getUserDisplayName(user, false, true);

/* Please change UserUtil.java if you change the logic here */
export const getUserDisplayName = (
  user: Pick<User, "username" | "firstName" | "lastName">,
  emptyIfNoFirstLast?: boolean,
  appendUsername?: boolean,
): string => {
  if (!user) {
    return "";
  }

  let name = "";

  if (user.firstName) {
    name += `${user.firstName} `;
  }

  if (user.lastName) {
    name += `${user.lastName} `;
  }

  if (name.length === 0 && !emptyIfNoFirstLast) {
    name = `${user.username} `;
  } else if (appendUsername) {
    name += `(${user.username})`;
  }

  return name.trim();
};

export const getInitialsForUser = (user: Pick<User, "username" | "firstName" | "lastName">): string => {
  if (user == undefined) return "";
  return user.firstName && user.lastName
    ? user.firstName.slice(0, 1) + user.lastName.slice(0, 1)
    : (user.username?.slice(0, 2) ?? "");
};

export const checkCapability = (capabilities: Capability[] | undefined | null, capability: CAPABILITY): boolean => {
  return capabilities != undefined && capabilities.some((c: Capability) => c.id === capability);
};

export function filterByCapability<T extends IRestrictedByCapability>(items: T[], capabilities: Capability[]): T[] {
  if (items) {
    return items.filter((item: T) => !item.capability || checkCapability(capabilities, item.capability));
  }
  return [];
}
